import * as React from 'react';
export const avalancheSvg = React.forwardRef(function avalancheSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#E84142',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#fff',
      d: 'M7.657 23.728h3.362c.792 0 1.188 0 1.541-.098.388-.115.741-.32 1.035-.6.27-.258.464-.598.848-1.27l.012-.02 4.361-7.71c.388-.677.58-1.018.664-1.375a2.529 2.529 0 0 0 0-1.184c-.084-.355-.278-.693-.66-1.36l-.008-.015-1.707-2.98c-.353-.62-.532-.932-.758-1.047a.857.857 0 0 0-.774 0c-.226.115-.405.426-.758 1.048L6.51 21.753c-.349.612-.523.919-.51 1.17.017.273.157.52.387.669.213.136.562.136 1.269.136Zm16.674 0h-4.82c-.71 0-1.068 0-1.276-.137a.862.862 0 0 1-.388-.672c-.012-.25.163-.552.515-1.16l.01-.015 2.404-4.13c.353-.608.532-.91.754-1.025a.847.847 0 0 1 .77 0c.22.112.39.401.73.974l.028.048 2.413 4.129.035.06c.335.577.506.872.493 1.115a.852.852 0 0 1-.387.672c-.213.14-.57.14-1.282.14Z',
    }),
  );
});
avalancheSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var avalanche = {
  category: 'brand',
  colorable: false,
  name: 'avalanche',
  svg: avalancheSvg,
};
